<div class="card block isMinimizable"
     [stepContent]="revenusStepContent"
     joyrideStep="revenusStep">
    <div class="card-header">
        <div class="card-title">
            <h6>Total des loyers mensuelles
                <p class="value">{{ favorite.amount_rent| number:'1.0-0' }} €
                    + {{ favorite.amount_copro_rent| number:'1.0-0' }} €<span class="hide-mobile"> de charges</span></p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Loyers</h2>
        </div>
    </div>
    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/ss_revenus.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-12" *ngFor="let lot of favorite.lots; index as i">
                <div class="bg-light p-3 pb-0 rounded mb-3">
                    <div class="row">
                        <h3 class="col-12 mt-0">
                            {{ lot.title != '' ? lot.title : "Lot " + i }}
                            <span>{{ lot.estate_type }} de {{ lot.square }} m²
                                <ng-container
                                    *ngIf="lot.rooms > 0 && (lot.estate_type == 'Maison' || lot.estate_type == 'Appartement')"> - {{ lot.rooms }}
                                    pièces</ng-container></span>
                        </h3>
                        <div class="col-6">
                            <mat-form-field
                                [ngClass]="{'no_plan' : !authenticationService.isAllowed('basique')}">
                                <mat-label>Exploitation</mat-label>
                                <mat-select disableOptionCentering #selectFurnish [(ngModel)]="lot.furnish"
                                            (ngModelChange)="edit('furnish')">
                                    <mat-option [value]="0">Tous confondu</mat-option>
                                    <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 1)"
                                                [value]="1">Meublé
                                    </mat-option>
                                    <mat-option [disabled]="!cityService.hasFurnish(favorite.ad_city, 2)"
                                                [value]="2">Nu
                                    </mat-option>
                                    <mat-option [value]="3">Location courte durée
                                    </mat-option>
                                    <mat-option [value]="4">Colocation
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-6">
                            <mat-form-field *ngIf="lot.furnish == 0 || lot.furnish == 1 || lot.furnish == 2">
                                <mat-label>Simulation de loyer à {{ favorite.ad_city.name }}</mat-label>
                                <mat-select disableOptionCentering [(ngModel)]="lot.advice_rent_choice" (ngModelChange)="edit()">
                                    <mat-optgroup
                                        *ngFor="let group of rentChoice[i] | keyvalue: adService.sortGeneralFirst"
                                        [label]="group.key">
                                        <mat-option *ngFor="let value of group.value | keyvalue"
                                                    [disabled]="value.value == undefined || value.value.x0 == 0"
                                                    [value]="value.key">{{ cityService.rentFields[value.key].lib }}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="lot.furnish == 4">
                                <mat-label>
                                    Nombre de chambres
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="lot.rooms"
                                       (ngModelChange)="edit()">
                            </mat-form-field>
                            <ng-container *ngIf="lot.furnish == 3">
                                <div class="row">
                                    <div class="col-md-6 indicateur">
                                        <label>
                                            Total
                                        </label>
                                        <b>{{ lot.night_price * lot.night_number | number: '1.1-1' }}
                                            <span class="unit">€/mois</span></b>
                                    </div>
                                    <div class="col-md-6 indicateur">
                                        <label>
                                            Taux de remplissage
                                        </label>
                                        <b>{{ lot.night_number / 30 * 100 | number: '1.0-0' }}
                                            <span class="unit">%</span></b>
                                    </div>
                                </div>

                            </ng-container>
                        </div>

                        <div class="col-6" *ngIf="lot.furnish != 3">
                            <mat-form-field>
                                <mat-label>Loyer hors charges<i class="fa fa-info-circle"
                                                                matTooltip="Le montant du loyer mensuel sans les charges locatives."></i>
                                </mat-label>
                                <input type="number" step="100" matInput [(ngModel)]="lot.amount_rent"
                                       (ngModelChange)="edit()">
                                <span matSuffix>€/mois</span>
                            </mat-form-field>
                        </div>

                        <div class="col-6" *ngIf="lot.furnish != 3">
                            <mat-form-field>
                                <mat-label>Charges locataire
                                    <i class="fa fa-info-circle" matTooltip="Les charges appliquées en plus du loyer sont à renseigner ici. Ces charges sont payées par votre locataire et n’ont donc pas d’impact sur votre rendement et votre cash-flow, sauf dans 2 cas :
En cas de gestion par agence : le % de commission s’applique sur le montant charges comprises du loyer. Les charges locataires augmentent donc légèrement les frais d’agence
En cas de vacance locative :  Ce sera au propriétaire de payer les charges pendant que son logement sera vacant"></i>
                                </mat-label>
                                <input type="number" step="100" matInput [(ngModel)]="lot.amount_copro_rent"
                                       (ngModelChange)="edit()">
                                <span matSuffix>€/mois</span>
                            </mat-form-field>
                        </div>

                        <div class="col-12" *ngIf="lot.furnish != 3">
                            <div class="data_moy bg-white">
                                <h3 class="text-center">
                                    Estimations de loyer
                                    <ng-container *ngIf="favorite.lots.length == 1 && favorite.nb_lots > 1 && (lot.furnish == 0 || lot.furnish == 1 || lot.furnish == 2)">
                                        pour {{ favorite.nb_lots }} lots
                                    </ng-container>
                                    <ng-container *ngIf="lot.furnish == 4">
                                        pour {{ favorite.rooms }} chambres
                                    </ng-container>
                                    <i *ngIf="lot.advice_rent_choice && (lot.furnish == 0 || lot.furnish == 1 || lot.furnish == 2)" class="fa fa-info-circle"
                                       matTooltip="Estimation basée sur {{ favorite.lots.length == 1 && favorite.nb_lots > 1 ? favorite.nb_lots + ' logements' : 'un logement' }} {{ cityService.rentFields[lot.advice_rent_choice].lib }} de {{ favorite.square }}m² en location à {{ favorite.ad_city.name }}
Si une option n’est pas clicable, cela signifie qu’il n’y a pas suffisement d’annonces de location à {{ favorite.ad_city.name }} afin avoir des estimations fiables."></i>
                                    <i *ngIf="lot.advice_rent_choice && lot.furnish == 4" class="fa fa-info-circle"
                                       matTooltip="Estimation basée sur {{ favorite.rooms == 1 && favorite.rooms > 1 ? favorite.rooms + ' chambres' : 'une chambre' }} en colocation à {{ favorite.ad_city.name }}
Si une option n’est pas clicable, cela signifie qu’il n’y a pas suffisement d’annonces de location à {{ favorite.ad_city.name }} afin avoir des estimations fiables."></i>
                                </h3>
                                <div class="row justify-content-center">
                                    <div class="wrap">
                                        <div class="row">
                                            <div class="col-6 moy_price">
                                                <label>
                                                    Moyen <i class="fa fa-info-circle" matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte).
Il s’agit du loyer médian : 50% des logements similaires ont un loyer plus faible, et 50% ont un loyer plus élevé."></i>
                                                </label>
                                                <b class="value cursor-pointer" (click)="applyRent(lot.advice_rent, i)">
                                                    {{ lot.advice_rent == 0 ? '-' : lot.advice_rent | number:'1.0-0' }}
                                                    <span class="unit">€</span>
                                                </b>
                                            </div>
                                            <div class="col-6 range_price">
                                                <label>
                                                    Bas <i class="fa fa-info-circle" matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte).
Il s’agit du loyer bas : 25% des logements similaires ont un loyer plus faible, et 75% ont un loyer plus élevé."></i> :
                                                </label>
                                                <b class="value cursor-pointer"
                                                   (click)="applyRent(lot.advice_rent_L, i)">
                                                    {{ lot.advice_rent_L == 0 ? '-' : lot.advice_rent_L | number:'1.0-0' }}
                                                    <span class="unit">€</span>
                                                </b>
                                                <br/>
                                                <label>
                                                    Haut <i class="fa fa-info-circle" matTooltip="Estimation basée sur les informations fournies (ne prend pas en compte la qualité de l’appartement ni la localisation exacte).
Il s’agit du loyer haut : 75% des logements similaires ont un loyer plus faible, et 25% ont un loyer plus élevé."></i> :
                                                </label>
                                                <b class="value cursor-pointer"
                                                   (click)="applyRent(lot.advice_rent_U, i)">
                                                    {{ lot.advice_rent_U == 0 ? '-' : lot.advice_rent_U | number:'1.0-0' }}
                                                    <span class="unit">€</span>
                                                </b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-center confidence">
                                    Indice de confiance
                                    <i class="fa fa-circle{{ lot.advice_rent_cL >= 1 ? ' actif' : ''}}"
                                       aria-hidden="true"></i>
                                    <i class="fa fa-circle{{ lot.advice_rent_cL >= 2 ? ' actif' : ''}}"
                                       aria-hidden="true"></i>
                                    <i class="fa fa-circle{{ lot.advice_rent_cL >= 3 ? ' actif' : ''}}"
                                       aria-hidden="true"></i>
                                    <i class="fa fa-circle{{ lot.advice_rent_cL >= 4 ? ' actif' : ''}}"
                                       aria-hidden="true"></i>
                                    <i class="fa fa-circle{{ lot.advice_rent_cL >= 5 ? ' actif' : ''}}"
                                       aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>

                        <div class="col-6" *ngIf="lot.furnish == 3">
                            <mat-form-field>
                                <mat-label>Prix moyen par nuit
                                    <i class="fa fa-info-circle"
                                       matTooltip="Indiquer le loyer que vous allez pratiquer par nuit, en moyenne sur tous les mois de l’année."></i>
                                </mat-label>
                                <input type="number" step="10" matInput [(ngModel)]="lot.night_price"
                                       (ngModelChange)="edit('night_price')">
                                <span matSuffix>€/nuit</span>
                            </mat-form-field>
                        </div>

                        <div class="col-6" *ngIf="lot.furnish == 3">
                            <mat-form-field>
                                <mat-label>Nuités par mois
                                    <i class="fa fa-info-circle"
                                       matTooltip="Indiquer le nombre de nuit ou vous prévoyez que le logement sera loué par mois, en moyenne sur tous les mois de l’année."></i>
                                </mat-label>
                                <input type="number" step="1" matInput [(ngModel)]="lot.night_number"
                                       (ngModelChange)="edit('night_number')">
                                <span matSuffix>nuits/mois</span>
                            </mat-form-field>
                        </div>

                        <!--                        <div class="col-12 mb-3" *ngIf="lot.furnish == 3">-->
                        <!--                            Vous avez du mal à estimer les revenus de votre location courtée durée ? <a href="#">Cliquez ici</a>-->
                        <!--                        </div>-->
                    </div>

                    <div class="col-12" *ngIf="(lot.estate_type == 'Maison' || lot.estate_type == 'Appartement')
                         && cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice)
                         && lot.furnish != 3
                         && lot.furnish != 4
                         && cityService.rentFields[lot.advice_rent_choice] != undefined
                         && cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice).s_max > 0
                         && (cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice).s_min > (lot.square / lot.nb_lots) || cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice).s_max < (lot.square / lot.nb_lots))">
                        <div class="notif notif_warning w-100 mb-3">
                            <i class="fa fa-warning me-2"></i>
                            Attention : les valeurs renseignées ne correspondent pas au marché de cette ville. Un
                            {{ cityService.rentFields[lot.advice_rent_choice].lib }} en location dans ce secteur est
                            souvent compris entre
                            {{ cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice).s_min }} et
                            {{ cityService.getRentValue(favorite.ad_city, lot.advice_rent_choice).s_max }} m².
                            Les estimations de loyers peuvent donc êtres faussées
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #revenusStepContent>
    <div class="user_onboarding_content">
        <h2>Les revenus de votre projet</h2>
        <p>
            On passe maintenant <b>aux loyers</b> que vous allez toucher, beaucoup mieux non ?<br/>
            <br/>
            Vous devez renseigner <b>les loyers hors charges</b>. Si vous ne savez pas quel loyer appliquer, <b>LyBox
            vous donne un loyer conseillé</b> en fonction de la ville,
            de la typologie du bien et de sa superficie.<br/>
            <br/>
            <b>Astuce</b> : Si vous êtes sur un projet d’immeuble ou de colocation, vous pouvez cliquer sur “Ajouter
            manuellement un lot” et mettre un loyer différent
            pour chaque appartement ou pour chaque chambre
        </p>
    </div>
</ng-template>
